export const buttonClick = {
    whileTap: { scale: 0.95 },
};

export const fadeInOut = {
    initial: {opacity : 0},
    animate: {opacity : 1},
    exit: {opacity : 0, duration : 1}
}